const params = (page, pageSize, sortModel, filterModel) => {
  const urlParams = new URLSearchParams()
  urlParams.append('page', page)
  if (pageSize !== 0) {
    urlParams.append('pageSize', pageSize)
  }

  if (sortModel.length > 0) {
    urlParams.append('sort', sortModel[0].field)
    urlParams.append('order', sortModel[0].sort)
  }

  filterModel.items.forEach((item) => {
    if (item.value !== undefined && item.value !== null) {
      urlParams.append(`${item.field}[${item.operator}]`, item.value)
    }
  })

  return urlParams
}

export default params
